import { RefObject, useMemo } from 'react';
import { AREngine, getMindTargetUrl, getPreferredAREngine } from '../utils/arEngine';
import { useXR8Scene } from './useXR8Scene';

export interface UseARSceneOptions {
    targetJsonUrl: string;
    sceneRef: RefObject<HTMLElement>;
}

export interface UseARSceneResult {
    engine: AREngine;
    ready: boolean;
    targetName: string | null;
    mindTargetUrl: string;
}

export const useARScene = ({
    targetJsonUrl,
    sceneRef,
}: UseARSceneOptions): UseARSceneResult => {
    const engine = useMemo(() => getPreferredAREngine(), []);
    const mindTargetUrl = useMemo(
        () => getMindTargetUrl(targetJsonUrl),
        [targetJsonUrl],
    );

    const { ready, targetName } = useXR8Scene(
        targetJsonUrl,
        sceneRef,
        engine === 'xr8',
    );

    if (engine === 'mindar') {
        return {
            engine,
            ready: true,
            targetName: null,
            mindTargetUrl,
        };
    }

    return {
        engine,
        ready,
        targetName,
        mindTargetUrl,
    };
};
